// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"b333e491","1395":"b333e491","5309":"b333e491","6360":"b333e491","7107":"b333e491","8028":"b333e491","8190":"b333e491","9591":"b333e491"}[chunkId] + ".chunk.css";
};